export function normalizeYmd(value) {
	if (!value) return '';
	if (typeof value === 'string') {
		const m = value.match(/^\d{4}-\d{2}-\d{2}/);
		return m ? m[0] : '';
	}
	const d = value instanceof Date ? value : new Date(value);
	if (Number.isNaN(d.getTime())) return '';
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, '0');
	const dd = String(d.getDate()).padStart(2, '0');
	return `${y}-${m}-${dd}`;
}

function clampYmdRange(startYmd, endYmd) {
	const s = String(startYmd || '');
	const e = String(endYmd || '');
	if (!s || !e) return { startYmd: s, endYmd: e };
	return s <= e ? { startYmd: s, endYmd: e } : { startYmd: e, endYmd: s };
}

function taskDoneLike(task) {
	const status = String(task?.status || '').trim().toLowerCase();
	if (status === 'gotovo' || status === 'done' || status === 'completed' || status === 'complete') return true;
	const progress = Number(task?.progress || 0);
	if (Number.isFinite(progress) && progress >= 100) return true;
	if (task?.completed_ymd || task?.completedYmd) return true;
	return false;
}

export function isAssignedToCurrentUser(taskOrAssignees, currentUser) {
	const myUserId = String(currentUser?.id || currentUser?.user_id || '').trim();
	if (!myUserId) return true;

	const assignees = Array.isArray(taskOrAssignees)
		? taskOrAssignees
		: (Array.isArray(taskOrAssignees?.assignees)
			? taskOrAssignees.assignees
			: (Array.isArray(taskOrAssignees?.task?.assignees)
				? taskOrAssignees.task.assignees
				: []));

	if (!Array.isArray(assignees) || assignees.length === 0) return true;
	return assignees.some(a => String(a?.id || a?.user_id || '').trim() === myUserId);
}

export function getTaskDateRange(task) {
	const start = normalizeYmd(task?.startDate || task?.start_date || task?.assignedDate || task?.assigned_for || task?.dueDate || task?.due_date);
	const end = normalizeYmd(task?.dueDate || task?.due_date || task?.startDate || task?.start_date || task?.assignedDate || task?.assigned_for);
	const { startYmd, endYmd } = clampYmdRange(start, end);
	return {
		start: startYmd || endYmd || '',
		end: endYmd || startYmd || '',
	};
}

export function isOverdue(task, options = {}) {
	const due = normalizeYmd(task?.dueDate || task?.due_date);
	if (!due) return false;
	if (taskDoneLike(task)) return false;

	const todayYmd = String(options?.todayYmd || '').trim();
	if (todayYmd && /^\d{4}-\d{2}-\d{2}$/.test(todayYmd)) {
		return String(due) < todayYmd;
	}

	const dueDate = new Date(`${due}T00:00:00`);
	const today = new Date();
	const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
	if (Number.isNaN(dueDate.getTime()) || Number.isNaN(todayStart.getTime())) return false;
	return dueDate < todayStart;
}

// Internal-only helper for UI state; keep logic centralized.
export function isDoneLike(task) {
	return taskDoneLike(task);
}
